const MS_IN_SECOND = 1000;
type ImpressionConfig = {
  type: string;
  secondsOnScreen: number;
  visibilityThreshold: number;
};

const impressionConfigs: Array<ImpressionConfig> = [
  {type: 'visible', secondsOnScreen: 0, visibilityThreshold: 0.01},
  {type: 'mrc', secondsOnScreen: 1, visibilityThreshold: 0.5},
  {type: 'ims', secondsOnScreen: 2, visibilityThreshold: 0.5},
];

const trackImpression = (
  element: HTMLElement,
  {type, secondsOnScreen, visibilityThreshold}: ImpressionConfig,
  onImpression: (type: string) => void,
) => {
  let timeout: NodeJS.Timeout | null = null;
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        timeout && clearTimeout(timeout);
        return;
      }

      if (!secondsOnScreen) {
        // трекается сам факт видимости
        onImpression(type);
        observer.disconnect();
        return;
      }

      timeout = setTimeout(() => {
        onImpression(type);
        observer.disconnect();
      }, secondsOnScreen * MS_IN_SECOND);
    },
    {
      threshold: visibilityThreshold,
    },
  );
  observer.observe(element);

  return () => {
    observer.disconnect();
    timeout && clearTimeout(timeout);
  };
};

export const trackImpressions = (
  element: HTMLElement,
  onImpression: (type: string) => void,
) =>
  impressionConfigs.map((config) =>
    trackImpression(element, config, onImpression),
  );
